import { MapPin, Phone, Clock, Mail, ArrowRight, Navigation } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/blocks";
import { IMAGES } from "@/data/content";
import { useCentre } from "@/context/CentreContext";
import { useUI } from "@/context/UIContext";

export default function Contact() {
  const { current, centres, setSelectorOpen } = useCentre();
  const { openLead } = useUI();
  const c = current || centres[0];

  return (
    <div data-testid="contact-page">
      <Seo title="Contact & devis | Horsepower Garage"
        description="Contactez Horsepower Garage : demande de devis, de rappel ou de rendez-vous dans le centre de votre choix. Réseau national de reprogrammation moteur."
        canonical="https://www.horsepowergarage.fr/contact" />
      <PageHero eyebrow="Contact" title="Parlons de votre projet"
        subtitle="Demandez un devis, un rappel ou un rendez-vous. Le contact s'adapte au centre que vous avez sélectionné."
        image={IMAGES.garage1} />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20 grid lg:grid-cols-2 gap-10">
        <Reveal>
          <div className="hp-card p-8">
            <div className="flex items-center justify-between gap-4 mb-6">
              <h2 className="font-display font-bold uppercase tracking-tight text-2xl">{c?.name || "Votre centre"}</h2>
              <button onClick={() => setSelectorOpen(true)} className="text-xs font-bold uppercase tracking-wide text-hp-yellow hover:underline" data-testid="contact-change-centre">Changer</button>
            </div>
            <ul className="space-y-4 text-neutral-300">
              {(c?.address || c?.postal_city) && <li className="flex items-start gap-3"><MapPin size={18} className="text-hp-yellow mt-0.5 shrink-0" /><span>{[c?.address, c?.postal_city].filter(Boolean).join(", ")}</span></li>}
              {c?.phone && <li className="flex items-center gap-3"><Phone size={18} className="text-hp-yellow shrink-0" /><a href={`tel:${c.phone.replace(/\s/g,"")}`} className="hover:text-hp-yellow">{c.phone}</a></li>}
              <li className="flex items-center gap-3"><Mail size={18} className="text-hp-yellow shrink-0" /><a href="mailto:direction@horsepower-garage.fr" className="hover:text-hp-yellow">direction@horsepower-garage.fr</a></li>
              {c?.hours && <li className="flex items-start gap-3"><Clock size={18} className="text-hp-yellow mt-0.5 shrink-0" /><span>{c.hours}</span></li>}
            </ul>
            {c?.maps_url && <a href={c.maps_url} target="_blank" rel="noopener noreferrer" className="hp-ghost mt-6 px-5 py-3 text-sm inline-flex items-center gap-2"><Navigation size={15} /> Itinéraire</a>}
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="hp-card p-8 h-full flex flex-col justify-center">
            <h2 className="font-display font-bold uppercase tracking-tight text-2xl">Une demande ?</h2>
            <p className="text-neutral-400 mt-3">Choisissez le type de demande, nous vous recontactons rapidement.</p>
            <div className="grid gap-3 mt-6">
              <button onClick={() => openLead({ request_type: "rappel", centre_slug: c?.slug })} className="hp-ghost px-6 py-4 text-sm flex items-center justify-between" data-testid="contact-rappel">Être rappelé <ArrowRight size={16} /></button>
              <button onClick={() => openLead({ request_type: "devis", centre_slug: c?.slug })} className="hp-ghost px-6 py-4 text-sm flex items-center justify-between" data-testid="contact-devis">Demander un devis <ArrowRight size={16} /></button>
              <button onClick={() => openLead({ request_type: "rdv", centre_slug: c?.slug })} className="hp-cta px-6 py-4 text-sm flex items-center justify-between" data-testid="contact-rdv">Prendre rendez-vous <ArrowRight size={16} /></button>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
